import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'chaoskit/src/components';

import { Icon } from '../../components';
import { createFullSingleUrl } from '../../../utils/helpers';

const ArticleFooter = ({ home, navigation, type }) => (
  <footer className="chaosMonkey__article-footer u-textHeading u-mt--xlarge u-textBold u-flex u-flexBetween u-flexMiddle">
    <Button
      disabled={!navigation.previous}
      type="reset"
      className="u-inlineBlock"
      url={
        navigation.previous
          ? createFullSingleUrl(type, navigation.previous)
          : null
      }
    >
      <Icon icon="caret-left" className="u-mr--small" />
      <span className="u-hiddenDown@small">Previous Section</span>
    </Button>
    <Button type="reset" className="u-inlineBlock" url={home}>
      <Icon icon="home" className="u-mr--small" />
      <span className="u-hiddenDown@small">Chaos Monkey</span>
    </Button>
    <Button
      disabled={!navigation.next}
      type="reset"
      className="u-inlineBlock"
      url={navigation.next ? createFullSingleUrl(type, navigation.next) : null}
    >
      <span className="u-hiddenDown@small">Next Section</span>
      <Icon icon="caret-right" className="u-ml--small" />
    </Button>
  </footer>
);

ArticleFooter.propTypes = {
  home: PropTypes.string,
  navigation: PropTypes.object,
  type: PropTypes.string,
};

ArticleFooter.defaultProps = {
  home: '/chaos-monkey/',
  navigation: {},
};

export default ArticleFooter;
